import type { Optional } from '@festina-life/core'

import { useComponent } from '../../lenteHooks'
import type { VouchersPostingType } from './VoucherModalContent'
type Props = {
  /** ID of the posting for which the voucher is being fetched. */
  postingId: string
  /** Sequence number of the posting being shown */
  sequenceNumber: Optional<number>
  /** Indicates whether the posting to fetch the voucher for is Balance or OpenPost posting */
  vouchersPostingType: VouchersPostingType
  /** Callback for when the modal is closed */
  onClose: () => void
}

export const PostingVoucherModal = ({
  postingId,
  sequenceNumber,
  vouchersPostingType,
  onClose,
}: Props) => {
  const VoucherModal = useComponent('pages.commitment.postings.VoucherModal')

  return (
    <VoucherModal
      postingId={postingId}
      titleName={sequenceNumber || postingId}
      vouchersPostingType={vouchersPostingType}
      onClose={onClose}
    />
  )
}
